import { useContext, useRef } from 'react'
import ReverTextField from '@/ui/components/portal-preview/pages/pages-components/rever-text-field'
import { usePortalTranslate } from '@/hooks'
import { useAppSelector } from '@/redux/hooks'
import { useSearchParams } from 'react-router'
import { EditedCopiesContext } from '@/ui/components/portal-preview/preview-contexts'
import { Button } from '@/ui/components/portal-preview/pages/pages-components/button'
import { usePreviewDevice } from '@/ui/components/portal-preview/use-portal-branding'

export const HorizontalForm = () => {
  const editedCopies = useContext(EditedCopiesContext)
  const { translate } = usePortalTranslate(editedCopies)

  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )
  const eCommerceName = settings.name
  const returnsPolicyUrl = settings.external_return_policy_url

  const [searchParams] = useSearchParams()
  const preSelectedOrderNumber = searchParams.get('orderNumber')
  const preSelectedEmail = searchParams.get('email')

  // Eligibility handler
  const email = useRef<HTMLInputElement>(null)
  const orderNumber = useRef<HTMLInputElement>(null)
  const isDesktop = usePreviewDevice() === 'desktop'

  return (
    // The portal keeps this form at a phone's width whatever the screen, centred under the banner.
    <form
      className={
        'mt-8 flex flex-col content-center items-center px-10 ' +
        (isDesktop ? 'w-full max-w-96' : 'w-[83%]')
      }
    >
      <ReverTextField
        data-testid="orderNumber"
        ref={orderNumber}
        label={translate('landing_numorder')}
        placeholder="X01234"
        defaultValue={preSelectedOrderNumber}
        fullWidth
        autoFocus
      />
      <div className="mt-4 w-full">
        <ReverTextField
          data-testid="email"
          ref={email}
          defaultValue={preSelectedEmail}
          label={translate('landing_email')}
          placeholder={
            translate('landing_email_example') + '@' + settings.slug + '.com'
          }
          fullWidth
        />
      </div>

      <div className="mt-4 flex justify-center px-10 max-[374px]:w-full">
        <Button type="submit">{translate('landing_button_continue')}</Button>
      </div>
      <div className="mt-4 text-center text-xs text-grey-3">
        {returnsPolicyUrl ? (
          <a
            className="text-center text-sm text-grey-2 underline"
            href={returnsPolicyUrl}
            target="_blank"
            rel="noreferrer"
            dangerouslySetInnerHTML={{
              __html:
                translate('landing_returns_policy') + (eCommerceName ?? '')
            }}
          />
        ) : null}
        <div className="mt-4">
          {translate('landing_user_politics1') + ' '}
          <a
            className="text-xs text-grey-3 underline"
            href="https://itsrever.com/user-terms/"
            target="_blank"
            rel="noreferrer"
            dangerouslySetInnerHTML={{
              __html: translate('landing_user_politics2')
            }}
          />
          {' ' + translate('landing_user_politics3') + ' '}
          <a
            className="text-xs text-grey-3 underline"
            href="https://itsrever.com/user-terms/"
            target="_blank"
            rel="noreferrer"
            dangerouslySetInnerHTML={{
              __html: translate('landing_user_politics4')
            }}
          />
        </div>
      </div>
    </form>
  )
}

export default HorizontalForm
